export default __webpack_public_path__ + "static/media/AUTORES_16.a5a7c1b3.png";